import { render } from "./KnowledgePointAdmin.vue?vue&type=template&id=3f1cc201&scoped=true"
import script from "./KnowledgePointAdmin.vue?vue&type=script&lang=js"
export * from "./KnowledgePointAdmin.vue?vue&type=script&lang=js"

import "./KnowledgePointAdmin.vue?vue&type=style&index=0&id=3f1cc201&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1cc201"]])

export default __exports__